import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const lithiaConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Lithia Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Lithia, FL. Sam\'s Tree Service handles large and dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_lithia',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Lithia',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Lithia Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we handle the large scale tree work 
     that comes with owning property in <strong>Lithia</strong>. This rural and 
     semi rural community in Southeast Hillsborough County features spacious lots, 
     creek frontage, and the kind of dense tree cover that becomes a serious 
     liability after a storm. Massive oaks, tall pines, and overgrown canopies 
     near homes and outbuildings all require professional management and that's 
     exactly what our team delivers.`,

    `We specialize in <strong>large lot and rural tree removal and hazard 
     mitigation</strong> full tree takedowns on acreage properties, post storm 
     debris clearing from driveways and structures, large canopy reductions near 
     homes and barns, and creek bank tree work that requires experience with 
     wet and unstable soil conditions.`,

    `<strong>Sam's Tree Service</strong> provides reliable, affordable tree care 
     throughout <strong>Lithia</strong> and the surrounding 
     <strong>Southeast Hillsborough</strong> rural corridor keeping your 
     land, structures, and trees safe and well managed year round.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Lithia, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Lithia = () => <LocationPage config={lithiaConfig} />;
export default Services_Lithia;
